import fromAnyToUpperCase from 'utils/converters/any/fromAnyToUpperCase.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

const fromAnyToSearchName = (any) =>
  fromAnyToUpperCase(
    fromAnyToString(any)
      .normalize('NFD') // decompose combined graphemes
      .replace(/[\u0300-\u036f]/g, ''), // gets rid of diacritics
  );

export default fromAnyToSearchName;
